import React from 'react';
import Image from 'next/legacy/image';
import { Box, Button, Heading, Paragraph, createButtonPrimaryColorConfig } from '@99designs/emu';
import { IconDown4 } from '@99designs/icons';
import Attribution from '../../common/Attribution';
import ContentSideFeature from '../../common/ContentSideFeature';

interface Props {
    onCtaClick: () => void;
}

export default function Hero({ onCtaClick }: Props) {
    return (
        <ContentSideFeature
            side={
                <Box display="flex" flexDirection="column">
                    <Box display="flex">
                        <Image src="/images/Fe_Melo.jpg" alt="" width={600} height={600} />
                    </Box>
                    <Box display="flex" justifyContent="flex-start">
                        <Attribution name="Fe Melo" size="root" url="/profiles/1062426" />
                    </Box>
                </Box>
            }
            top={
                <Box style={{ color: '#2E28F0' }} maxWidth={['auto', 'auto', 'auto', '511px']}>
                    <Heading
                        appearanceLevel={0}
                        accessibilityLevel={1}
                        withDivider
                        color="chameleon"
                    >
                        Giving small businesses a big (design) boost
                    </Heading>
                </Box>
            }
            bottom={
                <Box maxWidth={['auto', 'auto', 'auto', '511px']}>
                    <Box marginLeft={['none', '2bu']} marginTop={'2bu'}>
                        <Paragraph>
                            We’re proud to help revitalize 99 businesses around the world through 99
                            Days of Design. In collaboration with our partners, we’re helping these
                            inspiring entrepreneurs transform their brand through the power of great
                            design.
                        </Paragraph>
                    </Box>
                    <Box marginTop="2bu">
                        <Button
                            width={['fill', 'auto', 'auto', 'auto']}
                            appearance={createButtonPrimaryColorConfig({
                                color: '#2E28F0',
                                backgroundColorHover: '#5853F3',
                                backgroundColorActive: '#0806E2',
                            })}
                            icon={{ component: IconDown4, position: 'right' }}
                            size="large"
                            onClick={onCtaClick}
                        >
                            Check out their stories
                        </Button>
                    </Box>
                </Box>
            }
        />
    );
}
